import { Browse } from 'spa/components/browse'
import { Layout, Sidebar } from 'spa/components/layout'
import React from 'react'
import TagSearch from './tag_search'

const display = () => {
  return (
    <Layout tabTitle="genres">
      <Sidebar>
        <Browse />
      </Sidebar>
      <TagSearch />
    </Layout>
  )
}

export { display as TagSearchDisplay }

export { TagSearch }

export default TagSearch
